import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["answer", "icon"];

  toggle(event) {
    const button = event.currentTarget;
    const answer = button.parentElement.querySelector(
      '[data-faq-target="answer"]'
    );
    const icon = button.querySelector('[data-faq-target="icon"]');

    const isOpen = !answer.classList.contains("hidden");

    this.answerTargets.forEach((el) => el.classList.add("hidden"));
    this.iconTargets.forEach((el) => (el.textContent = "+"));

    if (!isOpen) {
      answer.classList.remove("hidden");
      icon.textContent = "−";
    }
  }
}
